<br>
  <div class="p-grid">
    <div class="p-col-12">
      <h4>Message To Customer Templates</h4>
    </div>
  </div>
  <br>
    <form id="templateLevelForm" #templateLevelForm="ngForm">
      <div class="p-grid">
        <div class="p-col-10">
          <h6>Name</h6>
          <input pInputText #templateNameInput name="name" [(ngModel)]="template.name" required fluid />
        </div>
        <div class="p-col-2">
          <h6>Active</h6>
          <p-toggleswitch class="toggle" name="activeToggle" [(ngModel)]="template.active"></p-toggleswitch>
        </div>
        <div class="p-col-12">
          <h6>Message</h6>
          <textarea
            pInputTextarea
            name="message"
            [(ngModel)]="template.message"
            [rows]="5"
            required
            style="width: 100%;">
          </textarea>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          @if (templateLevelForm.invalid && templateLevelForm.submitted) {
            <div class="alert alert-danger" role="alert">
              There are errors on this page. Please correct the errors and resubmit.
            </div>
          }
        </div>
        <div class="p-col-12" style="text-align: right">
          <p-button
            type="submit"
            (click)="saveTemplate(templateLevelForm)"
            [disabled]="saving"
            severity="success"  
            label="Save">
          </p-button>
          <p-button
            type="button"
            severity="warn"  
            (click)="clear(templateLevelForm);"
            label="Clear">
          </p-button>
        </div>
      </div>
    </form>
    <br>
      <br>
        <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="templates" [paginator]="true" [rows]="30">
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field" [style.width]="col.width">
                  {{col.header}}
                  @if (col.header != '') {
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  }
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-template
            let-columns="columns"
            let-rowIndex="rowIndex">
            <tr>
              <td><span class="p-column-title">{{columns[0].header}}</span>{{template.name}}</td>
              <td style="white-space: pre-wrap"><span class="p-column-title">{{columns[1].header}}</span>{{template.message}}</td>
              <td><span class="p-column-title">{{columns[2].header}}</span>{{template.active ? 'Yes' : 'No'}}</td>
              <td>
                <p-button
                  
                  type="button"
                  icon="pi pi-pencil"
                  (click)="editTemplate(template)"
                  severity="info" >
                </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <br>

